import { State, StoryQuery } from '../state';
import { Dispatch } from 'redux';
import { getPledgeParams, Routes } from '../../utils/routerHelper';
import { History } from 'history';
import { setStoryQuery, patch, handleUnexpectedError } from '../actions/all';
import * as selectors from '../selectors';
import { ExtraArguments } from '../extraArguments';

export const initializePledgePage = (history: History) => async (dispatch: Dispatch, getState: () => State, { i18n }: ExtraArguments) => {
  dispatch(patch({ spinner: true }));

  const t = i18n.getFixedT(i18n.language, 'pledge');

  const params = getPledgeParams(history.location, i18n);

  const entityStoryQuery: StoryQuery = {
    entityID: 0,
    userID: 0,
    competitionPledgeID: params.competitionPledgeID,
    storyID: 0
  };
  await setStoryQuery(entityStoryQuery)(dispatch, getState);

  try {
    const state = getState();
    const api = selectors.userApi(state);
    const { token } = state;
    const res = await api.getCompetitionPledge(params.competitionPledgeID, token);
    const pr = getState().pendingRoute;
    const stateAfterFetch = getState();
    const competitionPledges = res.competitionPledge
      ? {
        ...(stateAfterFetch.competitionPledges || {}),
        [res.competitionPledge.id]: res.competitionPledge
      }
      : undefined;
    dispatch(patch({
      ...res,
      competitionPledges,
      spinner: false,
      pendingRoute: pr === Routes.Pledge ? null : pr
    }));
  } catch (err) {
    handleUnexpectedError(err, {
      title: t('Oops!'),
      message: t('We experienced an error retrieving stories.')
    })(dispatch, getState);
    const pr = getState().pendingRoute;
    dispatch(patch({
      storyPagination: { nextPage: -1 },
      pendingRoute: pr === Routes.Pledge ? null : pr
    }));
  }
};

const refreshActionsListUserState = () => async (dispatch: Dispatch, getState: () => State) => {
  const state = getState();
  const { competition, token } = state;
  if (!competition || !token || !selectors.isLoggedIn(state)) {
    return;
  }
  try {
    const api = selectors.userApi(state);
    const res = await api.getMe(undefined, competition.name);
    if (res.competitionUserScores) {
      dispatch(patch({
        competitionUserScores: res.competitionUserScores,
        userPledgeCompletions: res.userPledgeCompletions,
        userPledgePoints: res.userPledgePoints
      }));
    }
  } catch (err) {
    // Non-fatal: list can still render with existing state.
  }
};

export const initializePledgeCategoryPage = () => async (dispatch: Dispatch, getState: () => State) => {
  dispatch(patch({ pendingRoute: null }));
  await refreshActionsListUserState()(dispatch, getState);
};

// Refresh authenticated dashboard scores when opening the Actions list.
// Visiting individual pledge pages previously wiped competitionUserScores in Redux,
// which made Novice+ levels appear locked despite earned points.
export const initializePledgesPage = () => async (dispatch: Dispatch, getState: () => State) => {
  dispatch(patch({ pendingRoute: null }));
  await refreshActionsListUserState()(dispatch, getState);
};
